import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../Types';
import PopoverContent from './ProgramExperienceCard/PopoverContent';

export interface Props {
  experienceResource: Maybe<ExperienceResource>;
  sectionIndex: number;
  editable?: boolean;
}

function ListProgramViewExperience({ experienceResource, sectionIndex, editable = true }: Props) {
  return experienceResource
    .map((resource) => (
      <div className="mt-6 flex flex-col gap-3 sm:mt-14">
        <PopoverContent
          experienceResource={resource}
          sectionIndex={sectionIndex}
          editable={editable}
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ListProgramViewExperience);
